export interface Note {
  _id: string;
  entityId: string;
  entityType: NoteEntityType;
  ghlNoteId: string;
  ghlContactId: string;
  studioId: string;
  note: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export enum NoteEntityType {
  Student = 'Student',
  Parent = 'Parent',
}
